export const SIM_IMG_URL = 'https://static.beeline.ru/upload/images/b2c/sim.svg';
